// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__7QGPl","section-1":"Federal_section-1__w6Qh-","content":"Federal_content__P5PDn","ul":"Federal_ul__xhLYj","section-2":"Federal_section-2__PTJD0"};